export const REGEX =
  /((https?:\/\/)?(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

export const FORM_META: Record<
  string,
  {
    favicon: string;
    domain: string;
  }
> = {
  google: {
    favicon: "https://www.storydoc.com/assets/images/companies/google-icon.svg",
    domain: "google.com",
  },
  hubspot: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/hubspot-icon.svg",
    domain: "hubspot.com",
  },
  jotform: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/jotform-icon.svg",
    domain: "jotform.com",
  },
  typeform: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/typeform-icon.svg",
    domain: "typeform.com",
  },
  custom: {
    favicon: "https://www.storydoc.com/assets/images/companies/code.svg",
    domain: "Code",
  },
};
